export function transformKeysToPascalCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map(transformKeysToPascalCase);
    }

    if (obj && typeof obj === 'object' && Object.prototype.toString.call(obj) === '[object Object]') {
        return Object.entries(obj).reduce((acc, [key, value]) => {
            const newKey = key.charAt(0).toLowerCase() + key.slice(1);
            acc[newKey] = transformKeysToPascalCase(value);
            return acc;
        }, {});
    }

    return obj;
}